import { inject, isDevMode } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

import { IdentityCommonService } from '@auth';

export const testGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);
    const identityCommonService = inject(IdentityCommonService);

    if (isDevMode()) {
        return true
    }

    router.navigate([identityCommonService.getLandingPath()], { relativeTo: activatedRoute.parent });
    return false;
};
